import SingleQueue from '../pages/requests/single-queue'
export default SingleQueue
